// Change in Cart
function updateQuantity(line,quantity) {
  $('.cdrawer-chekout-btn').addClass("disabled_cls");
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    success: function(cart) {
      $('.cdrawer-chekout-btn').addClass("disabled_cls");
      //       subtotalUpdate();
      //       gift1();
    },
  });
}
// ===============================================================================
// Fetch product to cart Drawer

$(document).ready(function() {

    const upsellProductHandles = [];upsellProductHandles.push('patralekhas-on-the-go-makeup-kit-upsell');upsellProductHandles.push('glow-boosting-gel-creme-with-mulethi-and-khus-upsell');upsellProductHandles.push('jojoba-and-wheatgerm-moisturising-sunscreen-gel-with-spf-35-pa-upsell');function initUpsellProducts() {
      $.ajax({
        type: 'GET',
        url: '/cart.js',
        cache: false,
        dataType: 'json',
        success: function(cart) {
          cartJson = cart;
          cart.items.forEach(function(item) {
            var cartIndex = upsellProductHandles.findIndex((upsellProuduct=> upsellProuduct===item.handle ))            
            upsellProductHandles.splice(cartIndex, 1);
          })
        }
      });
          
      if(upsellProductHandles.length) {
        var queries = [];
        
        for (var i=0; i < upsellProductHandles.length; i++) {
          queries.push(fetch('/products/' + upsellProductHandles[i] + '.js'));
        }
                
        Promise.all(queries).then(function(responses) {
          Promise.all(responses.map(function (response) {
            return response.json();
          })).then(function (products) {
             generateProductHtml(products);
          });    
        }) 
      }
      else {
		 $('.checkout-upsell').show();
      }
    } 
    
    function generateProductHtml(products) {
      var html = '';
      products = products.filter(function(p) { return p.available; });
      
      $.getJSON('/cart', function(cart) {
        for (var i=0; i < products.length; i++) {
          var product = products[i];
          var variants = product.variants.filter(function(v) { return v.available; });
          var currentVariant = variants[0];
          var productExists = false;

          for(var j=0; j < cart.items.length; j++){
            if(cart.items[j].variant_id === currentVariant.id) {
              if(cart.items[j].properties) {
                if(cart.items[j].properties._offer_upsell) {
                  productExists = true;
                }
              }
            }
          }

          html += '<div class="checkout-upsell__product">';
          html += '<div class="upsell-product">';
          html += '<div class="upsell-product__imagewrap">';
          html += '<img src="'+ product.featured_image +'" class="upsell-product__image" alt="'+ product.title +'" />';
          html += '</div>';

          html += '<div class="upsell-product__info">';
          html += '<div class="upsell-product__title">'+ product.title +'</div>';
          html += '<div class="upsell-product__prices">';
          html += '<span class="upsell-product__discountprice">₹'+ (currentVariant.price / 100 - (0.0 * (currentVariant.price / 100 ))) +'</span>';
          html += '<span class="upsell-product__price">₹'+ currentVariant.compare_at_price / 100 +'</span>';        
          html += '</div>';

          if(!productExists) {
            html += '<button class="btn upsell-product__button js-upsell-add" data-variant-id="'+ currentVariant.id +'">Add to Cart</button>';
          } 
          else {
            html += '<button class="btn upsell-product__button is--added">Added</button>';        
          }

          html += '</div>';
          html += '</div>';
          html += '</div>';
        }

        $('.js-upsell-products').html(html);

        $('.order-summary__sections').css({'height':'unset'})
        $('.checkout-upsell').insertAfter('.order-summary__section--product-list').show();
      })      
    }
    
    //Add to Cart
    $(document).on('click', '.js-upsell-add', function(evt) {
      evt.preventDefault();
      
      var variantId = $(this).attr('data-variant-id');
      var formData = {
        items: [{
          id: variantId,
          quantity: 1,
          properties: {
            '_offer_upsell': true
          }
        }]
      };
      
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: formData,
        dataType: 'json',
        success: function (response) {
          window.cartRefresh();
        },
        error: function () {
          location.reload();
        }
      });        
    });      
      function setTimer(duration) {
      	var timer = duration, minutes, seconds;
        console.log(timer);
        setInterval(function () {
          minutes = parseInt(timer / 60, 10)
          seconds = parseInt(timer % 60, 10);
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;

          $('.js-upsell-timer').html(minutes + ":" + seconds);
          
          if(minutes == '00' && seconds == '00'){
         
            // $('.checkout-upsell').remove();
          }
          
          if (--timer < 0) {
            timer = 0;
          }
        }, 1000);
      }

      var time = 90;
      setTimer(time);
   

   async function checkCartPageitem(id){

    var fetchh = await fetch('/cart.js');
    var cart = await fetchh.json();
    var mymap =  await cart.items.map(items=>items.id)
    return await mymap.includes(id);
   
  }
   window.cartRefresh();
   $(document).on("click",".cv--atc:not(.add-bvc-box-product)",async function(e){
      let _this = $(this);
     console.log(_this.data("currency"),_this.data("price"),_this.data("productid"),_this.data("pid"),_this.data("title"))
      dataLayer.push({ 'ecommerce': null });
      dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
        	    'currency': _this.data("currency"),
        		'value':_this.data("price"),                        
        		'items': [{
        		'item_id':_this.data("productid"),
        		'id': _this.data("pid"),
        		'google_business_vertical': 'retail',
        		'item_name': _this.data("title"),
        		}]
        	}
        });
      e.preventDefault();
      $(this).attr('disabled', true);
      var dataid = Number($(this).parents("form").find("[name='id']").val()),
          datacol = $(this).attr("data-colection"),
         this_parents = $(this).parents('body').find('.template__offer-natural-makeup');
        let res = await checkCartPageitem(dataid);
         console.log(res,'res');
        // if(res == true && datacol == 'true' && this_parents.length == 0 ){
           //  var checklen = $(this).parents(".shopify-product-form").find(".alertMsg").length;
           // console.log(checklen,'checklen');
           //  if(checklen==0){
           //  $(this).parents(".shopify-product-form").append("<p class='alertMsg'>We're Sorry! Only 1 unit allowed per order</p>");
           //      var thiss = $(this);
           //      setTimeout(function(){ 
           //       $(thiss).parents(".shopify-product-form").find(".alertMsg").remove();
           //      }, 5000);
            
             
           //  }
           //   $(this).attr('disabled', false);
          // }
        // else{
        var data = $(this).parents('form').serialize();
            console.log(data,'data');
        var dataid = $(this).parents('form').find("input[name='id']").val();
         var datahandle = $(this).attr("data-handle");
            console.log('datahandle',datahandle);
        var this3 = $(this); 
             var qty = 1;
             $.ajax({
               type: 'POST',
               url: '/cart/add.js',
               data: data,
               dataType: 'html',
               success:  function(response){
        
                 jQuery.getJSON('/cart.js',   function(cart) {
        
                   if(cart.item_count > 0){
                     $(".cartLinkBtn span").text(cart.item_count);
                     $(".cartLinkBtn span").addClass("active");
                   } else{
                     $(".cartLinkBtn span").removeClass("active");
                     $(".cartLinkBtn span").text("");
                   }
                   setTimeout(function(){ 
                  var specificitem =   cart.items.filter(item => item.id==dataid);
                   var src =  specificitem[0].image;
                   var h2 =   specificitem[0].title;
                   popupSuccessFree(src,h2);
                   }, 200);
                   
                 
                   
                 });
                 $('.cross').click(function(){
                   $('.cart__drawer').removeClass('show-cart__drawer');
                 });
        
                 
                    
                 subtotalUpdate();
                 gift1();
                 window.cartRefresh();
                 setTimeout(()=>{
                            applyCouponAuto();
               },500);
                    $(this3).val("ADDING...");
           setTimeout(() => {
                      $(this3).val("ADDED!");
         }, "1500")
        
         $(this3).val("ADDING...");
        setTimeout(() => {
                   $(this3).val("ADD TO CART");
           $(this3).attr('disabled', false);
        }, "2000")
             },
                error: function (error) {
             
           var myobj = JSON.parse(error.responseText);
               
                  var dataid = $(this3).parents('form').after("<p class='erroehandle'>"+myobj.description+"</p>");
             
                  setTimeout(() => {
                    $(".erroehandle").remove();
                     $(this3).attr('disabled', false);
                    }, "3000")
                
            }
        
                    });
        
  // }
   });

  /* Gpay page js start here */
  $(document).on("click",".gpay-cv--atc", function(e){
e.preventDefault();
const thisItem = $(this);
const checkadded = $(this).attr('added');
$(this).parents(".card--holder").siblings(".card--holder").find(".gpay-cv--atc").css("pointer-events","none");
setTimeout(function(){ 
    $(thisItem).parents(".card--holder").siblings(".card--holder").find(".gpay-cv--atc").css("pointer-events","unset");
}, 2000);
console.log('checkadded ',checkadded);
if(checkadded == 'true' || checkadded == true){
  $(this).parents(".shopify-product-form").append("<p class='alertMsg'>We're Sorry! Only 1 unit allowed per collection.</p>");
  var thiss = $(this);
  setTimeout(function(){ 
  $(thiss).parents(".shopify-product-form").find(".alertMsg").remove();
  }, 3000);
} else {
$(this).attr('disabled', true);
var dataid = Number($(this).parents("form").find("[name='id']").val());
var datacol = $(this).attr("data-colection");
var data = $(this).parents('form').serialize();
var dataid = $(this).parents('form').find("input[name='id']").val();
var datahandle = $(this).attr("data-handle");
var this3 = $(this); 
    var qty = 1;
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'html',
        success:  function(response){
        console.log('gpay product added');
        $(thisItem).parents('.gpay-feature-collection').find('.gpay-cv--atc').attr('added', true);
        jQuery.getJSON('/cart.js',   function(cart) {

            if(cart.item_count > 0){
            $(".cartLinkBtn span").text(cart.item_count);
            $(".cartLinkBtn span").addClass("active");
            } else{
            $(".cartLinkBtn span").removeClass("active");
            $(".cartLinkBtn span").text("");
            }

            setTimeout(function(){ 
            var specificitem = cart.items.filter(item => item.id==dataid);
            var src =  specificitem[0].image;
            var h2 =   specificitem[0].title;
            popupSuccessFree(src,h2);
            }, 200);
        });

        $('.cross').click(function(){
            $('.cart__drawer').removeClass('show-cart__drawer');
        });

        subtotalUpdate();
        gift1();
        window.cartRefresh();

        setTimeout(()=>{
          applyCouponAuto();
        },500);

        $(this3).val("ADDING...");

        setTimeout(() => {
            $(this3).val("ADDED!");
        }, "1500")

        $(this3).val("ADDING...");
        setTimeout(() => {
                    $(this3).val("ADD TO CART");
            $(this3).attr('disabled', false);
        }, "2000");

       },error: function (error){

        var myobj = JSON.parse(error.responseText);
        var dataid = $(this3).parents('form').after("<p class='erroehandle'>"+myobj.description+"</p>");
    
        setTimeout(() => {
            $(".erroehandle").remove();
            $(this3).attr('disabled', false);
            }, "3000")
        
      }

    });
   }
});
  /* Gpay page js end here */
});
// ===============================================================================


$(document).ready(function() {

  // Cart Drawer Open On Click Cart Icon
  $(document).on("click",".site-header__cart", function(e) {
    e.preventDefault();
    $('.cart__drawer').addClass('show-cart__drawer');
    $('body').addClass('cv--show-cart__drawer');
    console.log('codevibez');
  });
  // Cart Drawer Close On Click cross Icon
  $(document).on("click",".cross",function() {
    $('.cart__drawer').removeClass('show-cart__drawer');
    $('body').removeClass('cv--show-cart__drawer');
  });
  //   Close Cart Drawer click anywhere
  $(document).mouseup(function(e){
    var container = $(".cart__drawer");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      container.show();
      $('.cart__drawer').removeClass('show-cart__drawer');
      $('body').removeClass('cv--show-cart__drawer');
    }
  });
  
  // sticky qty js
  $('.quantity--input .quantity--input__button').click(function(){
    const sticky_qty = $(this).parents('.quantity--input').find('input').val();
    $('.quantity--input input').val(sticky_qty);
    



  });

});



// ===============================================================================


$(document).ready(function() {
  // Remove Item from Cart
   $(document).on("click",".cart__remove:not(._master)",function(e) {
    e.preventDefault();

    var itemVid = $(this).parents('.cart_items').data('variant-id');
    var itemUrl = $(this).attr('href');
    $.ajax({
      url: itemUrl,
      type:'GET',
      dataType: 'html',
      success: function(response){
        //         $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        //         $('.cart__drawer').html($(response).filter('.cart__drawer').html()); 
        gpayItemremover(itemVid,0);
        subtotalUpdate();
        gift1();
        window.cartRefresh();
            setTimeout(()=>{
         applyCouponAuto();
      },500);
      }
    });
  });

  // view cart drawer when view=cart
  var getPathName = window.location.hash;
  if(getPathName == '#viewcart'){
    history.replaceState(null, null, ' ');
    $('.cartLinkBtn').click();
  }
});

function gpayItemremover(itemId, itemQty){
    $('.cdrawer-chekout-btn').addClass("disabled_cls");
  var gpayCategeryLength = $('.gpay-feature-collection').length;
  if(gpayCategeryLength > 0 && itemQty == 0){
    $('.gpay-feature-collection form.shopify-product-form input[name="id"]').each(function(){
     const cVid = $(this).val();
      if(itemId == cVid){
        $(this).parents('.gpay-feature-collection').find('.gpay-cv--atc').attr('added',false);
      }
    });
  }
  console.log('itemId '+itemId+' itemQty '+itemQty);
}

// ===============================================================================




// Change In Quantity Selector
$(document).ready(function() {

  $(document).on("click",".plus",function() {
    
    if($(this).prev().val() >= Number($(this).attr("data-qty"))){
     return;
    }
    $(this).prev().val(+$(this).prev().val() + 1);
    
    var quantity = $(this).prev().val();
    
    
    
    var key = $(this).parents(".cart_items").attr("data-item-key");
    var data ={
  'id': key,
  'quantity': quantity
};
    var data2 =  $(this).parents('form').serialize();
     updateQuantity(data2,quantity);
    $.ajax({
      type: 'POST',
      url: '/cart/update',
      data: data2,
      dataType: 'json',
      success: function(response){
        //         $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        //         $('.cart__drawer').html($(response).filter('.cart__drawer').html());
       
        subtotalUpdate();
        gift1();
       // window.addmulti_gift();
        window.cartRefresh();
          setTimeout(()=>{
         applyCouponAuto();
      },500);
      },
      error: function (error) {
         
      }
    });

  });

  $(document).on("click",".minus",function() {
  
    $('.cdrawer-chekout-btn').addClass("disabled_cls");
    var $el = $(this),
      $input = $el.next(),
      val = parseInt($input.val());
    if (val >= 0) {
      val = val - 1;
      var data =  $el.parents('form').serialize();
      var quantity = val;
      updateQuantity(data,quantity);
      var itemVid = $el.parents('.cart_items').data('variant-id');
      $.ajax({
        type: 'POST',
        url: '/cart/update',
        data: data,
        dataType: 'html',
        success: function(response){
          //           $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
          //           $('.cart__drawer').html($(response).filter('.cart__drawer').html());
          gpayItemremover(itemVid,quantity);
          subtotalUpdate();
          gift1();
          
          window.cartRefresh();
          applyCouponAuto();
          setTimeout(function(){
          //  window.addmulti_gift();
          },1000)
        }
      });
    }
  });
});

subtotalUpdate();
function subtotalUpdate(){
  $.getJSON('/cart.js', function(cart) {
    var subTotal = cart.items_subtotal_price/100;
    $(".subtotal_price").text("MRP ₹ (Incl. of all taxes): ₹"+subTotal);

  });
}



gift1();

function gift1(){
  $.getJSON('/cart.js', function(cart) {
    
  });

  $(function() { 
    $.getJSON('/cart.js', function(cart) {
      var offerproduct = "Energising Pure Fragrances Fresh & Woody Worth Rs.499/-";
      var offerprices = "999";

      var totalprice = cart.total_price/100;
      console.log(totalprice, offerproduct, "<offerproduct")
      //if( totalprice > 599 ) { 
        $('.cdrawer-chekout-btn').addClass("disabled_cls");
      //}

      var calremainmoney = parseInt(999) - parseInt(totalprice);
      if( totalprice < 999 ) { 
        $('.offernudgeblock').html('<p>Add products worth <span class="morepriceleft">₹'+calremainmoney+'</span> more & get <span>'+offerproduct+'</span> free</p>');
        // console.log(calremainmoney);
      } else {
          console.log("Congratulations! You've got "+offerproduct, "<<<<<2")

        $('.offernudgeblock').html("Congratulations! You've got "+offerproduct);
      }
     
      
    });
     window.addmulti_gift();
  });
}

function gift2(){
$.getJSON('/cart.js', function(cart) {

});
  
  $(function() { 
    $.getJSON('/cart.js', function(cart) {
      var offerproduct = "Energising Pure Fragrances Fresh & Woody Worth Rs.499/-";
      var offerprices = "999";

      var totalprice = cart.total_price/100;
      console.log(totalprice, offerproduct, "<<offerproduct")

      var calremainmoney = parseInt(999) - parseInt(totalprice);
      if( totalprice < 999 ) { 
        $('.offernudgeblock').html('<p>Add products worth <span class="morepriceleft">₹'+calremainmoney+'</span> more & get <span>'+offerproduct+'</span> free</p>');
        // console.log(calremainmoney);
      } else {
        console.log("Congratulations! You've got "+offerproduct, "<<<<<1")
        $('.offernudgeblock').html("Congratulations! You've got "+offerproduct);
      }

    });
  });
  
}
window.cartRefresh = function(){
  $('.cdrawer-chekout-btn').addClass("disabled_cls");
  fetch(window.Shopify.routes.root + "?sections=drawer")
  .then(res => {return res.json()})
  .then((data) => {
//     console.log(data.drawer);
    $('#shopify-section-drawer .cart__drawer').html($(data.drawer).find('.cart__drawer').html());
//     applyCouponAuto();
  })
  jQuery.getJSON('/cart.js', function(cart) {
    let item_count = cart.item_count; 
    for(item of cart.items){ 
      if(item.properties._type && item.properties._type == "child")
        item_count--;
    }
    if(cart.item_count > 0){
      $(".cartLinkBtn span").text(item_count);
    $(".cartLinkBtn span").addClass("active");
      
    } else{
      $(".cartLinkBtn span").removeClass("active");
      $(".cartLinkBtn span").text("");
    }
    setTimeout(function(){
     $('.cdrawer-chekout-btn').removeClass("disabled_cls");
        },3000)
});
}

function popupSuccessFree(src,heading){
$(".free-popup-message").addClass('show');
$(".free-popup-message #img2").attr("src",src);
$(".free-popup-message h2").html(heading);   
fetch("/cart.js")
  .then(res=>res.json())
  .then(data=>{
    console.log(data);
  })
  setTimeout(()=>{
    $(".free-popup-message").removeClass('show');
  },3000);
}

            
            if(document.querySelectorAll(".filter__tags_base") != null){
            let len_filter = false;
            if(document.querySelectorAll(".filter__tags_base.active").length > 0){
            document.querySelector(".clear_all_btn").style.display = "block";
              document.querySelector(".filter__current-filters").classList.remove('filterClose');
            } else{
              if(document.querySelector(".clear_all_btn") != null){
                 document.querySelector(".clear_all_btn").style.display = "none";
                document.querySelector(".filter__current-filters").classList.add('filterClose');
              }
           
            }
            
            
            document.querySelectorAll(".filter__tags_base").forEach(item=>{
            item.onclick = async function (e){
            
            if(e.target.classList[0] == "scolor" || e.target.classList[0] == "cname"){
            if(e.target.parentNode.classList.contains('active')){
            e.target.parentNode.classList.remove("active");
            } else{
            e.target.parentNode.parentNode.querySelectorAll('.filter__tags_base').forEach(itm=>itm.classList.remove('active'));
            e.target.parentNode.classList.add("active");
            }
            } else{
            if(e.target.classList.contains('active')){
            e.target.classList.remove("active");
            } else{
            e.target.parentNode.querySelectorAll('.filter__tags_base').forEach(itm=>itm.classList.remove('active'));
            e.target.classList.add("active");
            } 
            }
            
            document.querySelector(".loader_cls").classList.add("active");
            let url = '';
            document.querySelectorAll(".filter__tags_base.active").forEach((itm,index)=>{
            if(index == 0){
            url = itm.getAttribute("data_href");
            } else{
            url += '+'+itm.getAttribute("data_href"); 
            }
            });
            
            if(document.querySelectorAll(".filter__tags_base.active").length > 0){
            document.querySelector(".clear_all_btn").style.display = "block";
              document.querySelector(".filter__current-filters").classList.remove('filterClose');
            } else{
              if(document.querySelector(".clear_all_btn") != null){
                document.querySelector(".clear_all_btn").style.display = "none";
                document.querySelector(".filter__current-filters").classList.add('filterClose');
              }
            
            }
            let main_base_url = "";
            if(e.target.classList[0] == "scolor" || e.target.classList[0] == "cname"){
            main_base_url = e.target.parentNode.getAttribute("data_main_url");
            } else{
            main_base_url = e.target.getAttribute("data_main_url");
            }
            
            
            if(document.querySelector(".sorting_collection_data") != null){
            if(document.querySelector(".sorting_collection_data.active") != null){
            let selec_sort_val = document.querySelector(".sorting_collection_data.active");
            var getvalue = selec_sort_val.getAttribute('data-sorting');
            url += '?sort_by='+getvalue;
            }
            }
            let data  = await fetch(main_base_url+url);
            let get_json = await data.text();
            let parser = new DOMParser();
            let doc = parser.parseFromString(get_json, 'text/html');
            
            setTimeout(function(){
            document.querySelector(".product__list").innerHTML = doc.querySelector(".product__list").innerHTML;
            document.querySelectorAll('.card__img--ratio img').forEach(function(item){
            var dsrc = item.getAttribute('data-srcset');
            item.setAttribute('src',dsrc);
            });
            history.pushState({}, null, main_base_url+url);
              if ($(window).width() < 767){ 
               $('.btn_filter').show();
              }
            },0);
            }
            })
            }
            
            if(document.querySelector(".close_filter_modal") != null){
            document.querySelector(".close_filter_modal").addEventListener("click",()=>{
            document.querySelector(".filter__mobile--button").click();
            });
            }
            
            if(document.querySelector(".clear_all_btn") != null){
            document.querySelector(".clear_all_btn").addEventListener("click",async (e)=>{
            let main_base_url = "";
            document.querySelectorAll(".filter__tags_base").forEach(item=>{
            item.classList.remove("active");
            main_base_url = item.getAttribute("data_main_url");
            });
            
            if(document.querySelector("#sort-by") != null){
            let selec_sort_val = document.querySelector("#sort-by");
            var getvalue = selec_sort_val.options[selec_sort_val.selectedIndex].value;
            main_base_url+'?sort_by='+getvalue;
            }
            
            
            let data  = await fetch(main_base_url);
            let get_json = await data.text();
            let parser = new DOMParser();
            let doc = parser.parseFromString(get_json, 'text/html');
            setTimeout(function(){
            document.querySelector(".product__list").innerHTML = doc.querySelector(".product__list").innerHTML;
            
              document.querySelectorAll('.card__img--ratio img').forEach(function(item){
            var dsrc = item.getAttribute('data-srcset');
            item.setAttribute('src',dsrc);
            });
            
            if(document.querySelectorAll(".filter__tags_base.active").length > 0){
            document.querySelector(".clear_all_btn").style.display = "block";
              document.querySelector(".filter__current-filters").classList.remove('filterClose');
            } else{
              if(document.querySelector(".clear_all_btn") != null){
                document.querySelector(".clear_all_btn").style.display = "none";
                document.querySelector(".filter__current-filters").classList.add('filterClose');
              }
            
            }
            document.querySelector(".filter__mobile--button").click();
            history.pushState({}, null, main_base_url);
             if ($(window).width() < 767){ 
               $('.btn_filter').show();
              }
            },0);
            })
            }
            
            $(document).on('click','.sorting_collection_data', async function(){
            $('.sorting_collection_data').removeClass('active');
            document.querySelector(".loader_cls").classList.add("active");
            $(this).addClass('active');
            // console.log(this.getAttribute("data-sorting"));
            const sUrl = this.getAttribute("data-sorting");
            let cUrl = $('.filter__group-title.sorting_title').data('chandle');
            let tagurl = '';
            $('.filter__tags_base.active').each(function(i){
            if(i == 0){
            tagurl = $(this).attr('data_href');
            }else{
            tagurl += '+'+$(this).attr('data_href');
            }
            });
            tagurl += '?sort_by='+sUrl;
            cUrl += '/'+tagurl
            
            let data  = await fetch(cUrl);
            let get_json = await data.text();
            let parser = new DOMParser();
            let doc = parser.parseFromString(get_json, 'text/html');
            
            setTimeout(function(){
            document.querySelector(".product__list").innerHTML = doc.querySelector(".product__list").innerHTML;
            document.querySelectorAll('.card__img--ratio img').forEach(function(item){
            var dsrc = item.getAttribute('data-srcset');
            item.setAttribute('src',dsrc);
            });
            history.pushState({}, null, cUrl);
            },0);
            
            });
            
            $(document).on('change','.sorting_body select#sort-by',function(){
            const sVal = $(this).val();
            $('.sorting_collection_data[data-sorting="'+sVal+'"]').click();
            });
            
            // if(document.querySelectorAll(".storebtn") != null){
            // document.querySelectorAll(".storebtn").forEach(item=>{
            // item.onclick = function(){
            // document.querySelectorAll(".storebtn").forEach(item2=>{
            // item2.classList.remove("active");
            // });
            // this.classList.add("active");
            // }
            // });  
            // }

$(document).on('click','button.storebtn',function(){
  $('button.storebtn').removeClass('active');
  $(this).addClass('active');
});

// $("#findshadmodal .btnselect").on("click", function(){
//   var title = $(this).attr("data-title");
//   $(this).parent().parent().parent().parent().parent().parent().next().find("#settitle").text(title);
//   var imageurlvar = $(this).attr("data-image");
//   $(this).parent().parent().parent().parent().parent().parent().next().find("#productimagevariant").attr('src',imageurlvar);
//   var vid = $(this).attr("data-vid");
//   $(this).parent().parent().parent().parent().parent().parent().next().find('#setidforaddtocart').attr('data-id',vid);
//   $("#v_id-"+vid).click();  
// });

// $("#findshadmodal .innermodal .imageboxcontainner .imageboxleft .imageboxleftinner .variantsection .textbox button").on("click", function(){
//   var modalcontentid = $(this).attr("data-modal"); 
//   //alert(modalcontentid);
//   $("#findshadmodal .modal_content-"+modalcontentid).hide();  
//   $("#findshadmodal .modal_content1-"+modalcontentid).show();  
// });

// $("#backpopup a").on("click", function(){
//   $(this).parent().parent().hide();
//   $(this).parent().parent().prev().show(); 
//   //   $("#findshadmodal .modal_contentbox1").hide();
//   //   $("#findshadmodal .modal_contentbox").show();  
//   $("#settitle").text("");
//   $("#findshadmodal #setidforaddtocart").text("Add to Cart");  
// });

// $("#findshadmodal .imageboxleft .variantsection ul li img").on("mouseenter",function(){
//   var imageurl = $(this).attr('src');
//   $("#imagesetonhover").attr('src',imageurl);  
// });

// $("#findshadmodal #setidforaddtocart").on("click", function(){
//   var variantforadd = $(this).attr("data-id");
//   data = { 
//     "id": variantforadd, 
//     "quantity": 1 
//   }
//   jQuery.ajax({
//     type: 'POST',
//     url: '/cart/add.js',
//     data: data,
//     dataType: 'json',
//     success: function(data) { 
//       //location.reload();
//       //$("#findshadmodal #setidforaddtocart").text("Added");
//       window.cartRefresh();
//      console.log('data ',data);
//       setTimeout(function(){ 
//         var h2 =   data.product_title;
//         var h3 = data.variant_title;
//         var src2 = data.image;
//         $(".free-popup-message h3").html("FREE PRODUCT - "+h2+"<span>"+h3+"</span>"); 
//         $(".free-popup-message #img1").attr("src",src2); 
//         $(".free-popup-message").addClass('show2');
//         setTimeout(()=>{
//         $(".free-popup-message").removeClass('show2');
//         $(".free-popup-message h3").html(" "); 
//         $(".free-popup-message #img1").attr("src"," ");
          
//         },3000);
//         }, 100);
//     }
//   });  

// });

// if($(window).width() < 768 ){
  
//   $(window).scroll(function() {    
//     var scroll = $(window).scrollTop();

//      //>=, not <=
//     if (scroll >= 500) {
//         //clearHeader, not clearheader - caps H
//         $(".stickyclass").addClass("stickycart");
//     }else{
//     $(".stickyclass").removeClass("stickycart");
//     }
// });

//   var windowH = $(window).height();
//   $("#findshadmodal .modal_contentbox").css("height",windowH );

//   $("#findshadmodal #groupbtn0").on("click" ,function(){

//     $(".modal_contentbox").animate({    
//       scrollTop:210
//     }); 
//   })

//   $("#findshadmodal #groupbtn1").on("click" ,function(){ 
//     var countspanm = $(this).children("span").size();
//     var spancountm = countspanm * 180 ; 
//     $(".modal_contentbox").animate({
//       scrollTop:spancountm 
//     });
//   })

//   $("#findshadmodal #groupbtn2").on("click" ,function(){ 


//     var coutsizeid1m = $("#findshadmodal #groupbtn1").children("span").size();

//     var countspan2m = $(this).children("span").size();

//     var countspanmain2m = coutsizeid1m + countspan2m;

//     var spancount2m = countspanmain2m * 182; 


//     $(".modal_contentbox").animate({ 
//       scrollTop:spancount2m
//     });
//   })

//   $("#findshadmodal #groupbtn3").on("click" ,function(){  

//     var coutsize1m = $("#findshadmodal #groupbtn1").children("span").size();
//     var coutsize2m = $("#findshadmodal #groupbtn2").children("span").size();
//     var countspan3m = $(this).children("span").size();
//     var countspanmain3m = coutsize1m + coutsize2m + countspan3m;
//     var spancount3m = countspanmain3m * 183;  
//     $(".modal_contentbox").animate({  
//       scrollTop:spancount3m 
//     });
//   }) ;


//   $("#findshadmodal .imageboxleftinner .variantsection ul li img").on("click", function(){

//     var getVariantName = $(this).parent().parent().prev().find(".titletext").html();
//     $("#imagezoommobile h3").html(getVariantName);
//     var imageurlmob = $(this).attr('src');
//     $("#imagezoommobile img").attr('src',imageurlmob); 
//     $("#imagezoommobile").show();

//   }); 

//   $("#closebigimage").on("click", function(){
//     $("#imagezoommobile").hide();
//   }); 
// }else{
//   $("#findshadmodal #groupbtn0").on("click" ,function(){ 
//     $(".imageboxleftinner").animate({    
//       scrollTop:1
//     }); 
//   })

//   $("#findshadmodal #groupbtn1").on("click" ,function(){ 

//     var countspan = $(this).children("span").size();
//     var spancount = countspan * 180 ;

//     $(".imageboxleftinner").animate({
//       scrollTop:spancount 
//     });
//   })

//   $("#findshadmodal #groupbtn2").on("click" ,function(){

//     var coutsizeid1 = $("#findshadmodal #groupbtn1").children("span").size();

//     var countspan2 = $(this).children("span").size();

//     var countspanmain2 = coutsizeid1 + countspan2;

//     var spancount2 = countspanmain2 * 182;

//     $(".imageboxleftinner").animate({ 
//       scrollTop:spancount2
//     });
//   })

//   $("#findshadmodal #groupbtn3").on("click" ,function(){ 
//     var coutsize1 = $("#findshadmodal #groupbtn1").children("span").size();

//     var coutsize2 = $("#findshadmodal #groupbtn2").children("span").size();

//     var countspan3 = $(this).children("span").size();

//     var countspanmain3 = coutsize1 + coutsize2 + countspan3;

//     var spancount3 = countspanmain3 * 183;

//     $(".imageboxleftinner").animate({ 
//       scrollTop:spancount3
//     });
//   })
// }

$("#findshade a").on("click", function(e){
   e.preventDefault();
       var variandataid = $(this).attr("data-id");
       
       $("#bgfindshadepopup").show();
       $("#findshadmodal").show();
      
      //$(".shademodal-"+variandataid).show();
      //var heightFsec = $("#forHeightSec").height();
      //var firsSectH = heightFsec * 3;   
     });

         $("#findshadmodal .modalclosetbn").on("click", function(){
      $("#bgfindshadepopup").hide();
      $(this).parent().parent().hide();
      $(this).next().show();
      $(this).next().next().hide();
   }); 
     
$("#findshadmodal .btnselect").on("click", function(){
  var title = $(this).attr("data-title");
  $(this).parent().parent().parent().parent().parent().parent().next().find("#settitle").text(title);
  var imageurlvar = $(this).attr("data-image");
  $(this).parent().parent().parent().parent().parent().parent().next().find("#productimagevariant").attr('src',imageurlvar);
  var vid = $(this).attr("data-vid");
  $(this).parent().parent().parent().parent().parent().parent().next().find('#setidforaddtocart').attr('data-id',vid);
  $("#v_id-"+vid).click();  
});


$("#findshadmodal .innermodal .imageboxcontainner .imageboxleft .imageboxleftinner .variantsection .textbox button").on("click", function(){
  var modalcontentid = $(this).attr("data-modal"); 
  //alert(modalcontentid);
  $("#findshadmodal .modal_content-"+modalcontentid).hide();  
  $("#findshadmodal .modal_content1-"+modalcontentid).show();  
});



$("#backpopup a").on("click", function(){
  $(this).parent().parent().hide();
  $(this).parent().parent().prev().show(); 
  //   $("#findshadmodal .modal_contentbox1").hide();
  //   $("#findshadmodal .modal_contentbox").show();  
  $("#settitle").text("");
  $("#findshadmodal #setidforaddtocart").text("Add to Cart");  
});




$("#findshadmodal .imageboxleft .variantsection ul li img").on("mouseenter",function(){
  var imageurl = $(this).attr('src');
  $("#imagesetonhover").attr('src',imageurl);  
});



$("#findshadmodal #setidforaddtocart").on("click", function(){
  var variantforadd = $(this).attr("data-id");
  data = { 
    "id": variantforadd, 
    "quantity": 1 
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
      success: function(data) { 
      // location.reload();
      $("#findshadmodal #setidforaddtocart").text("Added");
         setTimeout(function(){ 
        var h2 =   data.product_title;
        var h3 = data.variant_title;
        var src2 = data.image;
        $(".free-popup-message h3").html("FREE PRODUCT - "+h2+"<span>"+h3+"</span>"); 
        $(".free-popup-message #img1").attr("src",src2); 
        $(".free-popup-message").addClass('show2');
            window.cartRefresh(); 
        setTimeout(()=>{
        $(".free-popup-message").removeClass('show2');
        $(".free-popup-message h3").html(" "); 
        $(".free-popup-message #img1").attr("src"," ");
          
        },3000);
        }, 100);
    }
  });  

});





if($(window).width() < 768 ){
  
  $(window).scroll(function() {    
    var scroll = $(window).scrollTop();

     //>=, not <=
    if (scroll >= 500) {
        //clearHeader, not clearheader - caps H
        $(".stickyclass").addClass("stickycart");
    }else{
    $(".stickyclass").removeClass("stickycart");
    }
});

  var windowH = $(window).height();
  $("#findshadmodal .modal_contentbox").css("height",windowH );

  $("#findshadmodal #groupbtn0").on("click" ,function(){

    $(".modal_contentbox").animate({    
      scrollTop:210
    }); 
  })

  $("#findshadmodal #groupbtn1").on("click" ,function(){ 
    var countspanm = $(this).children("span").size();
    var spancountm = countspanm * 180 ; 
    $(".modal_contentbox").animate({
      scrollTop:spancountm 
    });
  })

  $("#findshadmodal #groupbtn2").on("click" ,function(){ 


    var coutsizeid1m = $("#findshadmodal #groupbtn1").children("span").size();

    var countspan2m = $(this).children("span").size();

    var countspanmain2m = coutsizeid1m + countspan2m;

    var spancount2m = countspanmain2m * 182; 


    $(".modal_contentbox").animate({ 
      scrollTop:spancount2m
    });
  })

  $("#findshadmodal #groupbtn3").on("click" ,function(){  

    var coutsize1m = $("#findshadmodal #groupbtn1").children("span").size();
    var coutsize2m = $("#findshadmodal #groupbtn2").children("span").size();
    var countspan3m = $(this).children("span").size();
    var countspanmain3m = coutsize1m + coutsize2m + countspan3m;
    var spancount3m = countspanmain3m * 183;  
    $(".modal_contentbox").animate({  
      scrollTop:spancount3m 
    });
  }) ;


  $("#findshadmodal .imageboxleftinner .variantsection ul li img").on("click", function(){

    var getVariantName = $(this).parent().parent().prev().find(".titletext").html();
    $("#imagezoommobile h3").html(getVariantName);
    var imageurlmob = $(this).attr('src');
    $("#imagezoommobile img").attr('src',imageurlmob); 
    $("#imagezoommobile").show();

  }); 

  $("#closebigimage").on("click", function(){
    $("#imagezoommobile").hide();
  }); 






}else{



  $("#findshadmodal #groupbtn0").on("click" ,function(){ 
    $(".imageboxleftinner").animate({    
      scrollTop:1
    }); 
  })

  $("#findshadmodal #groupbtn1").on("click" ,function(){ 

    var countspan = $(this).children("span").size();
    var spancount = countspan * 180 ;

    $(".imageboxleftinner").animate({
      scrollTop:spancount 
    });
  })

  $("#findshadmodal #groupbtn2").on("click" ,function(){

    var coutsizeid1 = $("#findshadmodal #groupbtn1").children("span").size();

    var countspan2 = $(this).children("span").size();

    var countspanmain2 = coutsizeid1 + countspan2;

    var spancount2 = countspanmain2 * 182;

    $(".imageboxleftinner").animate({ 
      scrollTop:spancount2
    });
  })

  $("#findshadmodal #groupbtn3").on("click" ,function(){ 
    var coutsize1 = $("#findshadmodal #groupbtn1").children("span").size();

    var coutsize2 = $("#findshadmodal #groupbtn2").children("span").size();

    var countspan3 = $(this).children("span").size();

    var countspanmain3 = coutsize1 + coutsize2 + countspan3;

    var spancount3 = countspanmain3 * 183;

    $(".imageboxleftinner").animate({ 
      scrollTop:spancount3
    });
  })
}

$(document).on('click', '.cart--checkout-button', function(){
  $('.cart--form .cart--body').addClass('cart--body-wrap');
});

$(document).on('click','button.storebtn',function(){
    $('button.storebtn').removeClass('active');
    $(this).addClass('active');
});

var interval = setInterval(function(){
  // console.log('not loaded');
  if($('div#ir_loyalty_widget').length > 0){
      console.log('loaded');
      $('div#ir_loyalty_widget').css('zIndex', '9');
      clearInterval(interval);
  }
},200);


if(document.querySelectorAll(".swatch--color") != undefined){
  document.querySelectorAll(".swatch--color").forEach(item => {
    item.onclick = () => {
    if(document.querySelector(".product__price--old") != undefined){
      document.querySelector(".product__price--old").style.display = 'none';
    }
  setTimeout(()=>{
    // if(document.querySelector(".product__price--sale") != undefined){
    //  document.querySelector(".product__price--sale").innerHTML = document.querySelector(".product__price--sale").innerHTML;
    // } 

    if(document.querySelector(".product__price--old") != undefined){
      document.querySelector(".product__price--old").innerHTML = document.querySelector(".product__price--old").innerHTML.replace("MRP ₹ (Incl. of all taxes): ","");
      document.querySelector(".product__price--old").style.display = 'block';
    }
  },1000);
      }
  });
}
function usePushState(handler){
    //modern themes use pushstate to track variant changes without reload
    function track (fn, handler, before) {
      return function interceptor () {
        if (before) {
          handler.apply(this, arguments);
          return fn.apply(this, arguments);
        } else {
          var result = fn.apply(this, arguments);
          handler.apply(this, arguments);
          return result;
        }
      };
    }
    var currentVariantId = null;
    function variantHandler () {
      var selectedVariantId = window.location.search.replace(/.*variant=(\d+).*/, "$1");
      if(!selectedVariantId) return;
      if(selectedVariantId != currentVariantId){
        currentVariantId = selectedVariantId;
        handler(selectedVariantId);
      }
    }
    // Assign listeners
    window.history.pushState = track(history.pushState, variantHandler);
    window.history.replaceState = track(history.replaceState, variantHandler);
    window.addEventListener("popstate", variantHandler);
  }
  usePushState(function(variantId){
    // if(document.querySelector(".product__price--sale") != undefined){
    //    document.querySelector(".product__price--sale").innerHTML = document.querySelector(".product__price--sale").innerHTML;
    //   } 

    if(document.querySelector(".product__price--old") != undefined){
      document.querySelector(".product__price--old").innerHTML = document.querySelector(".product__price--old").innerHTML.replace("MRP ₹ (Incl. of all taxes): ","");
    }
  });


function applyCouponAuto(){}

$(document).on('click','.free-popup-message a#openCartFree', function(e){
    e.preventDefault();
    $('body').addClass('cv--show-cart__drawer');
    $('.cart__drawer').addClass('show-cart__drawer');
});
$(document).on('click','.qtySelector-wrap',function(){
    var checklen = $(this).parents(".cart__items").find(".cart_alertMsg").length;
    if(checklen==0){
      $(this).parents(".cart__items").append("<p class='cart_alertMsg'>We're Sorry! Only 1 unit allowed per order</p>");
      setTimeout(function(){ 
      $('.cart__items').find(".cart_alertMsg").remove();
      }, 5000);
  }
});
  $(document).on('click','.dup_filter',function(e){
      e.preventDefault();
      var target = $(this).attr('target');
      $(`.filter__tag[data_href="${target}"]`).trigger('click');
      $('#filterToggle').prop('checked',false);
  });
  $(document).on('click','.dup_clear_all_btn',function(){
     $('.clear_all_btn').trigger('click');
    // setTimeout(function(){
    //   $('#filterToggle').prop('checked',false);
    //   },2000);
  });
  $(document).on('click','.btn_filter',function(){
      $('.filter__toggle').each(function(){
      $(this).prop('checked',false)
    })
      $('.filter_cls').trigger('click');
      $('.filter__group-title:first').trigger('click');
  });